import { Component } from '@angular/core';

import { AlertController, NavController } from 'ionic-angular';
import { ModalController, ViewController, ToastController } from 'ionic-angular';

import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { UserData } from '../../../providers/user-data';
import {UiData} from "../../../providers/ui-data";
import { CvAddForm } from './form/cvform';
import {Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import {DocumentSelectForm} from "../../utils/document-select/document-select";
import {MissionsListPage} from "../../missions/missions-list/missions-list";
import {CvDiplomasPage} from "./diplomas/diplomas";
import {CvCertificatesPage} from "./certificates/certificates";
import {CvExperiencesPage} from "./experiences/experiences";
import {CvLanguagesPage} from "./languages/languages";
import {DocumentsPage} from "../documents/documents";


@Component({
    selector: 'page-cv',
    templateUrl: 'cv.html'
})
export class CvPage {
    certificatesList: any;
    formationsRef: any;
    experiencesRef: any;
    certificatesRef: any;
    languagesRef: any;
    formations: Observable<any[]>;
    experiences: Observable<any[]>;
    certificates: Observable<any[]>;
    languages: Observable<any[]>;

    displayName: string ="";
    displayName2: string ="";
    displayNote: any ="";
    available: boolean = true;
    available_at: any = false;
    avatar: any = false;

    formations_length:any=0;
    certificates_length:any=0;
    experiences_length:any=0;
    languages_length:any=0;

    is_pe_connected:any = false;
    is_pe_activated:any = true;

    is_full_cv_activated:any = false;
    is_full_cv_existing:any = false;

    /*    formationsData: any;
        experiencesData: any;
        certificatesData: any;
        languagesData: any;*/

    constructor(
        public alertCtrl: AlertController,
        public nav: NavController,
        public userData: UserData,
        public uiData: UiData,
        public afDatabase: AngularFireDatabase,
        private formBuilder: FormBuilder,
        public modalCtrl: ModalController,
        public toastCtrl: ToastController,

    ) {
        this.certificatesList = {};
        //userData.setToken('nova2');
        this.certificatesList['certificate'] = uiData.certificatesList();
        this.certificatesList['permis']  = uiData.permisList();
        this.is_pe_activated = this.uiData.is_feat_on('pole_emploi_connect');
        this.is_full_cv_activated = this.uiData.is_feat_on('full_pdf_cv');
    }
    ngAfterViewInit() {

        var that = this;
        that.userData.userSession().subscribe(session => {
            if (session !== null) {
                that.userData.load().subscribe(user => {
                    that.formationsRef = that.userData.getUserDbListReference('formations');
                    that.experiencesRef = that.userData.getUserDbListReference('experiences');
                    that.certificatesRef = that.userData.getUserDbListReference('certificates');
                    that.languagesRef = that.userData.getUserDbListReference('languages');

                    that.formations = that.formationsRef.valueChanges();
                    that.formations.subscribe(function(data){
                        that.formations_length=data.length;
                    });
                    that.experiences = that.experiencesRef.valueChanges();
                    that.experiences.subscribe(function(data){
                        that.experiences_length=data.length;
                    });
                    that.certificates = that.certificatesRef.valueChanges();
                    that.certificates.subscribe(function(data){
                        that.certificates_length=data.length;
                    });
                    that.languages = that.languagesRef.valueChanges();
                    that.languages.subscribe(function(data){
                        that.languages_length=data.length;
                    });

                    let civility = that.userData.get('civility');
                    let ranking = that.userData.get('ranking');
                    let availability = that.userData.get('availability');

                    if (civility && civility.prenom && civility.nom) {
                        that.displayName = civility.prenom+" "+civility.nom ;
                        that.displayName2 = civility.email;
                    }
                    else if (civility && civility.prenom) {
                        that.displayName = civility.prenom ;//+ ' ' + civility.nom
                        that.displayName2 = civility.email;
                    }
                    else if(civility && civility.email) {
                        that.displayName = civility.email.split('@')[0];
                        that.displayName2 = civility.email;
                    }
                    if(ranking && ranking.note)
                    {
                        that.displayNote = ranking.note/5;
                    }
                    that.available = availability.available;
                    that.avatar = that.userData.getAvatar();

                    that.is_pe_connected = that.userData.isPeConnected();
                    that.is_full_cv_existing = that.userData.get('documents')['cv'];
                    if(that.is_pe_activated && !that.userData.isPeEnabled())
                    {
                        that.is_pe_activated=false;
                    }
                });
            }
        });




        /*this.userData.getToken().then(function(token){

            that.formationsRef = that.afDatabase.list('/users/'+token+'/formations');
            that.experiencesRef = that.afDatabase.list('/users/'+token+'/experiences');
            that.certificatesRef = that.afDatabase.list('/users/'+token+'/certificates');
            that.languagesRef = that.afDatabase.list('/users/'+token+'/languages');

            that.formations = that.formationsRef.valueChanges();
            that.experiences = that.experiencesRef.valueChanges();
            that.certificates = that.certificatesRef .valueChanges();
            that.languages = that.languagesRef.valueChanges();
        });*/
    }

    /****
     * Add or update Formation
     * Use Modal controller with parameters
     ****/
    addFormationModal() {
        let profileModal = this.modalCtrl.create(CvAddForm, { mode: "formations", ref:this.formationsRef, object: null });
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.toastSuccess('Formation ajoutée.');
                this.userData.triggerPortalSync({});
            }
            else
            {
                //this.toastSuccess('Opération annulée.');
            }
        });
        profileModal.present();
    }
    updateFormationModal(object) {
        let profileModal = this.modalCtrl.create(CvAddForm, { mode: "formations", ref:this.formationsRef, object: object });
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.toastSuccess('Formation modifiée.');
                this.userData.triggerPortalSync({});
            }
            else
            {
                //this.toastSuccess('Opération annulée.');
            }
        });
        profileModal.present();
    }
    /****
     * Add or update Experience
     * Use Modal controller with parameters
     ****/
    addExperienceModal() {
        let profileModal = this.modalCtrl.create(CvAddForm, { mode: "experiences", ref:this.experiencesRef, object: null });
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.toastSuccess('Expérience ajoutée.');
                this.userData.triggerPortalSync({});
            }
            else
            {
                //this.toastSuccess('Opération annulée.');
            }
        });
        profileModal.present();
    }
    updateExperienceModal(object) {
        let profileModal = this.modalCtrl.create(CvAddForm, { mode: "experiences", ref:this.experiencesRef, object: object });
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.toastSuccess('Expérience modifiée.');
                this.userData.triggerPortalSync({});
            }
            else
            {
                //this.toastSuccess('Opération annulée.');
            }
        });
        profileModal.present();
    }
    /****
     * Add or update Certificate
     * Use Modal controller with parameters
     ****/
    addCertificateModal() {
        let profileModal = this.modalCtrl.create(CvAddForm, { mode: "certificates", ref:this.certificatesRef, object: null });
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.toastSuccess('Certificat/Permis ajouté.');
                this.userData.triggerPortalSync({});
            }
            else
            {

            }
        });
        profileModal.present();
    }
    updateCertificateModal(object) {
        let profileModal = this.modalCtrl.create(CvAddForm, { mode: "certificates", ref:this.certificatesRef, object: object });
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.toastSuccess('Certificat/Permis modifié.');
                this.userData.triggerPortalSync({});
            }
            else
            {

            }
        });
        profileModal.present();
    }
    /****
     * Add or update Certificate
     * Use Modal controller with parameters
     ****/
    addLanguageModal() {
        let profileModal = this.modalCtrl.create(CvAddForm, { mode: "languages", ref:this.languagesRef, object: null });
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.toastSuccess('Langue ajoutée.');
                this.userData.triggerPortalSync({});
            }
            else
            {

            }
        });
        profileModal.present();
    }
    updateLanguageModal(object) {
        let profileModal = this.modalCtrl.create(CvAddForm, { mode: "languages", ref:this.languagesRef, object: object });
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.toastSuccess('Langue modifiée.');
                this.userData.triggerPortalSync({});
            }
            else
            {

            }
        });
        profileModal.present();
    }

    /***
     * Toast management
     * @param {string} message
     */

    toastSuccess(message: string)
    {
        let toast = this.toastCtrl.create({
            showCloseButton: true,
            cssClass: 'profile-bg',
            message: message,
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }
    toastCancel(message: string)
    {
        let toast = this.toastCtrl.create({
            showCloseButton: true,
            cssClass: 'profile-bg',
            message: message,
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

    removeExperience(experience)
    {
        var that = this;
        that.userData.update('experiences/'+experience.key,'disabled',true);
    }
    removeLanguage(language)
    {
        var that = this;
        that.userData.update('languages/'+language.key,'disabled',true);
    }
    removeCertificate(certificate)
    {
        var that = this;
        that.userData.update('certificates/'+certificate.key,'disabled',true);
    }
    removeFormation(formation)
    {
        var that = this;
        that.userData.update('formations/'+formation.key,'disabled',true);
    }
    changeRanking() {
        if(/*true ||*/ !this.userData.get('ranking') || !this.userData.get('ranking').ok)
        {
            this.nav.push('SelfRankingPage');
        }
        else
        {
            this.nav.push('RankingPage');
        }
    }
    chooseAvatar()
    {
        var multiple = false;
        var hideCamera = false;
        var fileExtensions:any = ".png, .jpg, .jpeg";
        var allowFileTypes:any = "image/*";
        var mode = 'avatar';

        let documentSelectModal = this.modalCtrl.create(DocumentSelectForm, {
            document_type: mode,
            multiple: multiple,
            hideCamera:hideCamera,
            fileExtensions:fileExtensions,
            allowFileTypes:allowFileTypes
        });
        var that = this;
        documentSelectModal.onDidDismiss(data => {
            that.avatar = that.userData.getAvatar();
            that.userData.update('documents/'+mode,'modified',true);
        });
        documentSelectModal.present();
    }
    formationsPage()
    {
        this.nav.push(CvDiplomasPage);
    }
    experiencesPage()
    {
        this.nav.push(CvExperiencesPage);
    }
    certificatesPage()
    {
        this.nav.push(CvCertificatesPage);
    }
    languagesPage()
    {
        this.nav.push(CvLanguagesPage);
    }
    documentsPage()
    {
        this.nav.push(DocumentsPage);
    }
    peConnect()
    {
        var that = this;
        let prompt = this.alertCtrl.create({
            cssClass: 'pe_connect',
            title: 'Connexion Pôle Emploi',
            subTitle: "Utilisez vos identifiants Pôle Emploi pour renseigner votre CV Novaterim.",
            message: "Pour cela, vous allez être redirigé vers le portail Pôle emploi pour vous connecter.",
            buttons: [
                {
                    text: "Oui, me connecter",
                    handler: data => {
                        that.userData.set('poleEmploiImport','pending');
                        window.open(that.userData.get('poleEmploiLink'), '_system');
                        var listener = that.userData.listen('poleEmploiImport','OK',function(){
                            listener.unsubscribe();
                            let prompt = that.alertCtrl.create({
                                cssClass: 'pe_connect',
                                title: 'Connexion Pôle Emploi',
                                subTitle: "Vos données ont été importées.",
                                message: "Merci.",
                                buttons: [
                                    {
                                        text: "Ok",
                                        handler: data => {
                                        }
                                    }
                                ]
                            });
                            prompt.present();
                        });
                        var listenerKo = that.userData.listen('poleEmploiImport','KO',function(){
                            listenerKo.unsubscribe();
                            let prompt = that.alertCtrl.create({
                                cssClass: 'pe_connect',
                                title: 'Connexion Pôle Emploi',
                                subTitle: "Vos données n'ont pas été importées.",
                                message: "Réessayez ultérieurement.",
                                buttons: [
                                    {
                                        text: "Ok",
                                        handler: data => {
                                        }
                                    }
                                ]
                            });
                            prompt.present();
                        })

                    }
                },
                {
                    text: "Non",
                    handler: data => {

                    }
                }
            ]
        });
        prompt.present();
    }
    peRefresh()
    {
        var that = this;
        let prompt = this.alertCtrl.create({
            cssClass: 'pe_connect',
            title: 'Connexion Pôle Emploi',
            subTitle: "Mettre à jour vos données depuis pôle emploi.",
            message: "Pour cela, vous allez être redirigé vers le portail Pôle emploi pour vous connecter.",
            buttons: [
                {
                    text: "Mettre à jour mes données",
                    handler: data => {
                        that.userData.set('poleEmploiImport','pending');
                        window.open(that.userData.get('poleEmploiLink'), '_system');
                        var listener = that.userData.listen('poleEmploiImport','OK',function(){
                            listener.unsubscribe();
                            let prompt = that.alertCtrl.create({
                                cssClass: 'pe_connect',
                                title: 'Connexion Pôle Emploi',
                                subTitle: "Vos données ont été mises à jour.",
                                message: "Merci.",
                                buttons: [
                                    {
                                        text: "Ok",
                                        handler: data => {
                                        }
                                    }
                                ]
                            });
                            prompt.present();
                        });
                        var listenerKo = that.userData.listen('poleEmploiImport','KO',function(){
                            listenerKo.unsubscribe();
                            let prompt = that.alertCtrl.create({
                                cssClass: 'pe_connect',
                                title: 'Connexion Pôle Emploi',
                                subTitle: "Vos données n'ont pas été mises à jour.",
                                message: "Réessayez ultérieurement.",
                                buttons: [
                                    {
                                        text: "Ok",
                                        handler: data => {
                                        }
                                    }
                                ]
                            });
                            prompt.present();
                        })

                    }
                },
               /* {
                    text: "Déconnecter mon compte Pôle-emploi",
                    cssClass: 'secondary',
                    handler: data => {

                    }
                },*/
                {
                    text: "Annuler",
                    role: 'cancel',
                    handler: data => {

                    }
                }
            ]
        });
        prompt.present();
    }
    chooseDocument(mode)
    {
        var multiple = false;
        var hideCamera = false;
        var fileExtensions:any = false;
        var allowFileTypes:any = false;

        if(mode == "identity" || mode == "vitale"){
            multiple = true;
        }
        if(mode == "cv"){
            hideCamera = true;
            fileExtensions = ".doc, .docx, .pdf, .odt";
            allowFileTypes = "application/pdf , application/msword , application/vnd.openxmlformats-officedocument.wordprocessingml.document , application/vnd.oasis.opendocument.text";
        }
        let documentSelectModal = this.modalCtrl.create(DocumentSelectForm, {
            document_type: mode,
            multiple: multiple,
            hideCamera:hideCamera,
            fileExtensions:fileExtensions,
            allowFileTypes:allowFileTypes
        });
        documentSelectModal.onDidDismiss(data => {
            if(data && data.document_type)
            {
                this.userData.update('documents/'+data.document_type,'modified',true);
            }
            else
            {

            }
        });
        documentSelectModal.present();
    }
}



// WEBPACK FOOTER //
// ./src/pages/account/cv/cv.ts